/* eslint-disable vue/multi-word-component-names */
import { Field, Form, ErrorMessage } from 'vee-validate';
import icon from '@/components/Icon.vue';
import tabs from '@/components/general/Tabs.vue';
import radioGroup from '@/components/general/RadioGroup.vue';
import slider from '@/components/general/Slider.vue';
import selects from '@/components/general/Selects.vue';
import checkbox from '@/components/general/Checkbox.vue';
import textField from '@/components/general/Textfield.vue';
import dateRange from '@/components/general/DateRange.vue';
import numberField from '@/components/general/NumberField.vue';
import switchToggle from '@/components/general/SwitchToggle.vue';
import checkboxGroup from '@/components/general/CheckboxGroup.vue';
import asset from '@/components/general/Asset.vue';
import schedule from '@/components/general/Schedule.vue';

const components = [
  {
    name: 'v-form',
    component: Form,
  },
  {
    name: 'v-field',
    component: Field,
  },
  {
    name: 'v-error-message',
    component: ErrorMessage,
  },
  {
    name: 'icon',
    component: icon,
  },
  {
    name: 'tabs',
    component: tabs,
  },
  {
    name: 'date',
    component: dateRange,
  },
  {
    name: 'radio',
    component: radioGroup,
  },
  {
    name: 'slider',
    component: slider,
  },
  {
    name: 'selects',
    component: selects,
  },
  {
    name: 'checkbox',
    component: checkbox,
  },
  {
    name: 'textField',
    component: textField,
  },
  {
    name: 'dateRange',
    component: dateRange,
  },
  {
    name: 'numberField',
    component: numberField,
  },
  {
    name: 'switchToggle',
    component: switchToggle,
  },
  {
    name: 'checkboxGroup',
    component: checkboxGroup,
  },
  {
    name: 'rangeSlider',
    component: slider,
  },
  {
    name: 'autocomplete',
    component: selects,
  },
  {
    name: 'asset',
    component: asset,
  },
  {
    name: 'schedule',
    component: schedule,
  },
];

const componentObj = {};
components.forEach((component) => {
  componentObj[component.name] = component.component;
});

export default {
  components,
  componentObj,
};
